import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class VsTabmenuIntegrationService {

  private currentTab: any = {};
  private isMenuOpen: boolean = false;
  private triggerJira: boolean = false;
  private currentPage: string = '';


  private tabSource = new BehaviorSubject(this.currentTab);
  public tabChanges = this.tabSource.asObservable();

  private menuOpenFlag = new BehaviorSubject(this.isMenuOpen);
  public menuOpenChanges = this.menuOpenFlag.asObservable();

  public ticketOpenFlag = new BehaviorSubject(this.triggerJira);
  public ticketOpenChanges = this.ticketOpenFlag.asObservable();

  private pageSource = new BehaviorSubject(this.currentPage);
  public pageChanges = this.pageSource.asObservable();

  constructor(private router: Router) {
  }

  changeTab(tab: any) {
    if (tab.tab || tab.subTabs) {
      // console.log('Tab ', tab);
      if (tab.subTabs) {
        this.tabSource.next(tab.subTabs);
      } else {
        this.tabSource.next(tab.subMenus);
      }
    } else {
      this.tabSource.next([]);
    }
  }

  changeMenuOpenState(isOpen: boolean) {
    this.menuOpenFlag.next(isOpen);
  }

  openJira(isOpen: boolean) {
    this.ticketOpenFlag.next(isOpen);
  }

  changePage(data: any) {
    if (data.label) {
      this.pageSource.next(data.label);
    } else {
      this.pageSource.next('');
    }
  }

  
}
